// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Select-menu-outer {
  overflow: hidden;
}

.Select {
  text-align: left;
  width: 100%;
}

.Select--multi .Select-loading {
  display: none;
}

.Select--multi .Select-option.is-selected {
  display: none;
}

.tagOnly .Select-menu-outer, .tagOnly .Select-arrow-zone{
  display: none;
}

.template-list-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Select--multi .Select-value-label {
  display: inline;
}

`, "",{"version":3,"sources":["webpack://./src/styles/overrides/react-select.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n.Select-menu-outer {\n  overflow: hidden;\n}\n\n.Select {\n  text-align: left;\n  width: 100%;\n}\n\n.Select--multi .Select-loading {\n  display: none;\n}\n\n.Select--multi .Select-option.is-selected {\n  display: none;\n}\n\n.tagOnly .Select-menu-outer, .tagOnly .Select-arrow-zone{\n  display: none;\n}\n\n.template-list-item {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.Select--multi .Select-value-label {\n  display: inline;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
